// 品牌 ECharts 主题：全站图表统一视觉语言（品牌主色随主题 + 财务语义色固定）
// 主序列色取自当前主题（theme.js），财务红绿（利润红/亏损绿）保持不变
import * as echarts from 'echarts';
import { getTheme, loadThemeKey } from '../theme.js';

// 当前主题主色（模块加载时已由 main.jsx 先 applyTheme 写好 data-theme 与 CSS 变量）
const _t = getTheme(loadThemeKey());

// 当前主题主色字符串（供 ECharts option 内 itemStyle/lineStyle/axisLabel 直接引用）
export const BRAND = _t.chartPrimary;
export const BRAND_STRONG = _t.brandStrong;
// 主色 RGB 分量（'r, g, b' 字符串），供 ECharts 半透明填充/阴影使用：rgba(${BRAND_RGB}, 0.12)
export const BRAND_RGB = _t.brandRgb;

// 品牌图表色板
// 第 1 位品牌主色 = 主序列（营收/主指标）；第 2 位利润红 = 正向财务（遵循国内红涨惯例）
export const BRAND_PALETTE = [
  _t.chartPrimary, // 品牌主色 · 主序列（随主题）
  '#CF1322', // 利润红 · 正向财务（固定）
  _t.brandStrong, // 品牌深色 · 第三序列（随主题）
  '#EF9F27', // 琥珀 · 警示/第四序列
  '#D4537E', // 玫红 · 第五序列
  '#378ADD', // 蓝 · 信息
  '#3F8600', // 财务绿 · 正向/成功（固定）
  '#7F77DD', // 紫
];

const brandTheme = {
  color: BRAND_PALETTE,
  backgroundColor: 'transparent',
  textStyle: {
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif",
    color: '#4A413A',
  },
  legend: {
    icon: 'circle',
    itemWidth: 8,
    itemHeight: 8,
    itemGap: 18,
    textStyle: { color: '#6B615A', fontSize: 12 },
    inactiveColor: '#C9C0B8',
  },
  tooltip: {
    backgroundColor: '#FFFFFF',
    borderColor: '#F0E6DE',
    borderWidth: 1,
    padding: [10, 14],
    textStyle: { color: '#3A322C', fontSize: 12 },
    extraCssText: 'border-radius:8px;box-shadow:0 4px 16px rgba(90,50,20,0.10);',
  },
  categoryAxis: {
    axisLine: { lineStyle: { color: '#E6DDD4' } },
    axisTick: { show: false },
    axisLabel: { color: '#8C8178', fontSize: 11 },
    splitLine: { show: false },
  },
  valueAxis: {
    axisLine: { show: false },
    axisTick: { show: false },
    axisLabel: { color: '#8C8178', fontSize: 11 },
    splitLine: { lineStyle: { color: '#F0E9E1', type: 'dashed' } },
  },
  line: {
    smooth: true,
    symbol: 'circle',
    symbolSize: 6,
    lineWidth: 2,
    emphasis: { focus: 'series' },
  },
  bar: {
    barMaxWidth: 26,
    itemStyle: { borderRadius: [4, 4, 0, 0] },
    emphasis: { focus: 'series' },
  },
  pie: {
    itemStyle: { borderColor: '#FFFFFF', borderWidth: 2, borderRadius: 4 },
    label: { color: '#4A413A', fontSize: 12 },
    labelLine: { lineStyle: { color: '#C9BFB5' } },
  },
};

echarts.registerTheme('brand', brandTheme);
